<template>
  <transition name="fade">
    <div class="fixed top-0 right-0 flex bg-gray-500/50 h-screen w-screen z-10"
         v-if="show">
      <transition name="slide" appear>
        <div class="h-screen w-[400px] bg-dark-foreground mr-auto p-6 print:mx-auto"
             @click.stop>

          <div class="flex justify-between items-center">
            <img src="../../assets/img/logo.png" alt="" class="w-10">
            <h1 class="text-lg text-center mr-4">{{ title }}</h1>
          </div>

          <hr class="border-dark-line my-5">
          
          <slot></slot>
          
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: "VSideModal",
  props: ['show', 'title']
}
</script>

<style scoped>

</style>